import { render, staticRenderFns } from "./Alexandru.vue?vue&type=template&id=e80e93ca&scoped=true"
import script from "./Alexandru.vue?vue&type=script&lang=js"
export * from "./Alexandru.vue?vue&type=script&lang=js"
import style0 from "./Alexandru.vue?vue&type=style&index=0&id=e80e93ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80e93ca",
  null
  
)

export default component.exports